'use client'

import {  Nav } from "react-bootstrap";
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';

import { useTranslations } from "next-intl";
import OSSNavLink from "components/OSSNavLink/OSSNavLink";
import LocaleSwitcher from "components/LocaleSwitcher";
import ossLogo from "images/oss_logo_xl.gif";
import ossArrows from "images/arrows.webp";
import ossArrows2 from "images/arrows2.webp";
import Image from 'next/image'

export default function Header() {
  const t=useTranslations('common');


  return (
    <Navbar style={{ backgroundColor: "white" }} expand="lg">
      <Container>
        <Navbar.Brand>
          <Image
            src={ossArrows}
            alt="OSS Arrows"
            width="80"
            height="30"
            className="d-inline-block align-top"
            loading="eager"
          />
          <Image
            src={ossLogo}
            alt="OSS Logo"
            width="80"
            height="30"
            className="d-inline-block align-top"
            loading="eager"
          />
          <Image
            src={ossArrows2}
            alt="OSS Arrows2"
            width="80"
            height="30"
            className="d-inline-block align-top"
            loading="eager"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav>
            <OSSNavLink path="/">
              {t("home")}
            </OSSNavLink>
            <OSSNavLink path="/services">
              {t("our_services")}
            </OSSNavLink>
            <OSSNavLink path="/team">
              {t("team")}
            </OSSNavLink>
            <OSSNavLink path="/contact">
              {t("contact")}
            </OSSNavLink>
            <OSSNavLink path="/imprint">
              {t("imprint")}
            </OSSNavLink>
            <LocaleSwitcher />
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );

}
